import { Text as VisxText, TextProps as VisxTextProps } from '@visx/text';
import { chartTheme } from './chartHelper';

export default function ChartText({ ...props }: VisxTextProps) {
    const defaultProps: VisxTextProps = {
        fontSize: chartTheme.fontSize,
        fill: chartTheme.colors.label,
    };

    return <VisxText {...{ ...defaultProps, ...props }} />;
}
